import { render, staticRenderFns } from "./studentTrackRecord.vue?vue&type=template&id=0bad54de&scoped=true"
import script from "./studentTrackRecord.vue?vue&type=script&lang=js"
export * from "./studentTrackRecord.vue?vue&type=script&lang=js"
import style0 from "./studentTrackRecord.vue?vue&type=style&index=0&id=0bad54de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bad54de",
  null
  
)

export default component.exports